import {
  Home,
  Building,
  UserCog,
  Users,
  ShieldAlt,
  LocationArrow,
  Wifi,
  MapPin,
  MailBulk,
  FolderOpen,
  List,
  BroadcastTower,
  Wrench,
  InfoCircle,
  Key,
  ChartBar,
  Info,
  UniversalAccess,
  Barcode,
  Bolt,
  DoorOpen,
  FileArchive,
  Clock,
  UserClock,
  ExclamationTriangle,
  HouseUser,
  Elementor,
  Microchip,
  SlidersH,
  Signal,
  UserShield,
  UsersCog,
  DiceD20,
} from '@vicons/fa'

export const menuOptions = [
  {
    label: 'Home',
    key: 'home',
    icon: Home.render,
    items: [
      {
        label: 'Dashboard',
        key: 'dashboard',
        icon: ChartBar.render,
        to: '/dashboard',
        checkPermission: false,
      },
    ],
  },
  {
    label: 'Trackables',
    key: 'assets-group',
    icon: Bolt.render,
    items: [
      {
        label: 'Assets',
        key: 'assets',
        icon: Barcode.render,
        to: '/assets',
        permissionUri: '/assets',
      },
    ],
  },
  {
    label: 'Access Control',
    key: 'access-control',
    icon: UniversalAccess.render,
    items: [
      {
        label: 'Enterprises',
        key: 'enterprises',
        icon: Building.render,
        to: '/enterprises',
        permissionUri: '/enterprises',
      },
      {
        label: 'Roles',
        key: 'roles',
        icon: UserCog.render,
        to: '/roles',
        permissionUri: '/roles',
      },
      {
        label: 'Users',
        key: 'users',
        icon: Users.render,
        to: '/users',
        permissionUri: '/roles',
      },
      {
        type: 'divider',
      },
      {
        label: 'Online Users',
        key: 'ongoing-sessions',
        icon: UserClock.render,
        to: '/users/ongoing-sessions',
        permissionUri: '/users/ongoing-sessions',
      },
      {
        type: 'divider',
      },
      {
        label: 'Permissions',
        key: 'permissions',
        icon: ShieldAlt.render,
        to: '/permissions',
        permissionUri: '/permissions',
      },
    ],
  },
  {
    label: 'Config',
    key: 'config',
    icon: UserShield.render,
    items: [
      {
        label: 'Item Types',
        key: 'inventoryItemTypes',
        icon: DiceD20.render,
        to: '/inventoryItemTypes',
        permissionUri: '/inventoryItemTypes',
      },
      {
        label: 'Sites',
        key: 'sites',
        icon: LocationArrow.render,
        to: '/sites',
        permissionUri: '/sites',
      },
      {
        label: 'Location Maps',
        icon: Elementor.render,
        key: 'location-maps',
        to: '/floors',
        permissionUri: '/floors',
      },
      {
        label: 'Read Zones',
        key: 'readzones',
        icon: Wifi.render,
        to: '/readzones',
        permissionUri: '/readzones',
      },
      {
        label: 'Location Tags',
        key: 'location-tags',
        icon: MapPin.render,
        to: '/location-tags',
        permissionUri: '/location-tags',
      },
      {
        label: 'Trackstar Mailers',
        key: 'notification-configs',
        icon: MailBulk.render,
        to: '/notification-configs',
        permissionUri: '/notification-configs',
      },
      {
        type: 'divider',
      },
      {
        label: 'Categories',
        key: 'categories',
        icon: FolderOpen.render,
        to: '/categories',
        permissionUri: '/categories',
      },
      {
        label: 'Pick Lists',
        key: 'pick-lists',
        icon: List.render,
        to: '/picklist-values',
        permissionUri: '/picklist-values',
      },
      {
        type: 'divider',
      },
      {
        label: 'Impinj Configs',
        key: 'impinj-configs',
        icon: Microchip.render,
        to: '/readers/configs/impinj',
        permissionUri: '/readers/configs/impinj',
      },
      {
        label: 'Zebra Configs',
        key: 'zebra-configs',
        icon: SlidersH.render,
        to: '/readers/configs/zebra',
        permissionUri: '/readers/configs/zebra',
      },
      {
        label: 'Standard Configs',
        key: 'standard-configs',
        icon: DiceD20.render,
        to: '/readers/configs/standard',
        permissionUri: '/readers/configs/standard',
      },
      {
        type: 'divider',
      },
      {
        label: 'RFID Readers',
        key: 'readers',
        icon: Signal.render,
        to: '/readers',
        permissionUri: '/readers',
      },
      {
        label: 'Zebra Printers',
        key: 'printers',
        icon: BroadcastTower.render,
        to: '/printers',
        permissionUri: '/printers',
      },
      {
        type: 'divider',
      },
      {
        label: 'Remote Command Configs',
        key: 'remote-command-configs',
        icon: Wrench.render,
        to: '/remote-command-configs',
        permissionUri: '/remote-command-configs',
      },
      {
        label: 'Broadcast Messages',
        key: 'broadcast-messages',
        icon: BroadcastTower.render,
        to: '/broadcast-messages',
        permissionUri: '/broadcast-messages',
      },
    ],
  },
  {
    label: 'Reports',
    key: 'reports',
    icon: FileArchive.render,
    items: [
      {
        label: 'Movements History',
        key: 'movement-history',
        icon: Clock.render,
        to: '/movement-history',
        permissionUri: '/inventory/scan-history',
      },
      {
        type: 'divider',
      },
      {
        label: 'Error Logs',
        key: 'error-logs',
        icon: ExclamationTriangle.render,
        to: '/remote-error-logger',
        permissionUri: '/logs',
      },
      {
        label: 'User Activity',
        key: 'user-activity',
        icon: UsersCog.render,
        to: '/reports/user-activity',
        permissionUri: '/user-activity',
      },
    ],
  },
  {
    label: 'Help',
    key: 'help',
    icon: Info.render,
    items: [
      {
        label: 'Profile',
        key: 'profile',
        icon: HouseUser.render,
        checkPermission: false,
      },
      {
        label: 'Change Password',
        key: 'changePassword',
        icon: Key.render,
        checkPermission: false,
      },
      {
        type: 'divider',
      },
      {
        label: 'About',
        key: 'about',
        icon: InfoCircle.render,
        checkPermission: false,
      },
    ],
  },
]
